import { render, staticRenderFns } from "./customImage.vue?vue&type=template&id=455ecff2&scoped=true&"
import script from "./customImage.vue?vue&type=script&lang=js&"
export * from "./customImage.vue?vue&type=script&lang=js&"
import style0 from "./customImage.vue?vue&type=style&index=0&id=455ecff2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455ecff2",
  null
  
)

export default component.exports